import { twMerge } from "tailwind-merge";
import { Card, CardContent, CardHeader, H5, H6 } from "@sellar-io/components";

export const OrderContactSummary = ({
  buyerContactSmsNumber,
  buyerEmail,
}: {
  buyerContactSmsNumber: string | null;
  buyerEmail: string;
}): React.ReactElement => {
  return (
    <Card className="bg-white">
      <CardHeader className={twMerge("bg-white", "flex items-center p-4")}>
        <H5>Contact</H5>
      </CardHeader>
      <CardContent className={"p-4"}>
        <div className="flex flex-col gap-2">
          <div className="grid grid-cols-2">
            {buyerContactSmsNumber && (
              <div className="col-span-1 flex flex-col gap-1">
                <H5>Mobile number</H5>
                <H6 className={"select-text"}>{buyerContactSmsNumber}</H6>
              </div>
            )}
            <div className="col-span-1 flex flex-col gap-1">
              <H5>Email</H5>
              <H6
                className={
                  "overflow-hidden text-nowrap text-ellipsis select-text"
                }
              >
                {buyerEmail}
              </H6>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
